<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M12.9.5a1 1 0 0 0-1 1V3a1 1 0 1 0 2 0V1.5a1 1 0 0 0-1-1M4.5 10.8a1 1 0 1 1 0-2H6a1 1 0 0 1 0 2zm16.7 0a1 1 0 1 0 0-2h-1.5a1 1 0 0 0 0 2zm-15-6.2a1 1 0 0 1 1.5-1.4l1 1a1 1 0 0 1-1.4 1.5zm13.3-1.4a1 1 0 0 1 0 1.4l-1 1A1 1 0 1 1 17 4.4l1-1a1 1 0 0 1 1.5 0m-6.9 2a1 1 0 0 1 1 0h.1v.1l.2.2.7 1a55 55 0 0 1 5.6 10 .7.7 0 0 1-1.4.5l-1.8.6a35 35 0 0 0-2.6-5.2L11 7.5l1.5-1.3a1 1 0 0 1 0-1m2.9 12.7v.1l-2.9 1 .1.4a3.2 3.2 0 1 1-6.2 1.7l-.1-.5L5 21q-1.2.3-2.2-.7l-1-1.8q-.4-1.3.5-2.3A142 142 0 0 1 10 8.6v.1a35 35 0 0 1 3 4.5zM8.3 20v.5a1.3 1.3 0 1 0 2.5-.7v-.4z"
      clip-rule="evenodd"
    />
  </svg>
</template>
